module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chat-window"
  }, [_c('div', {
    staticClass: "chat-header"
  }, [_c('h3', [_vm._v("Mensagens")]), _vm._v(" "), _c('button', {
    staticClass: "close-btn",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "chat-body"
  }, [(!_vm.activeRoomId) ? _c('chat-room-list', {
    on: {
      "select": _vm.selectRoom
    }
  }) : _c('chat-room', {
    attrs: {
      "roomId": _vm.activeRoomId
    },
    on: {
      "back": _vm.backToList
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06936231","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/plugins/chat-plugin/components/ChatWindow.vue
// module id = 1651
// module chunks = 18